import React from 'react';

export function PatientAvatar({ patient, size = 'md', className = '' }) {
  const dims = { sm: 'w-9 h-9 text-sm rounded-xl', md: 'w-14 h-14 text-xl rounded-2xl', lg: 'w-20 h-20 text-2xl rounded-3xl' }[size];
  const src = patient?.profile_image ? `${process.env.REACT_APP_BACKEND_URL}${patient.profile_image}` : null;
  if (src) {
    return <img data-testid="patient-avatar-img" src={src} alt={patient?.name || 'Patient'} className={`${dims} object-cover shrink-0 ring-2 ring-white/15 ${className}`} />;
  }
  return (
    <div data-testid="patient-avatar-initial" className={`${dims} grid place-items-center font-semibold text-white shrink-0 ${className}`} style={{ background: 'linear-gradient(135deg,#A855F7,#7C3AED)' }}>
      {(patient?.name || 'P').charAt(0)}
    </div>
  );
}
